//Libraries
import _ from 'lodash';
import moment from 'moment';

//Components
import Section from '../../components/section';
import Header from '../../components/pageHeader';
import LongPress from '../../components/longPress';
import CalendarActions from './calendarActions.js';
import SectionSpacing from '../../components/sectionSpacing';
import CalendarComponent from '../../components/calendar.js';

//Styling
import './calendar.scss'
import '../../dashboard.scss';
import colours from './../../utilities/colours.scss';

//Functions and Data
import config from './config';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, { useEffect, useState } from 'react';
import { fetchDates } from '../../../../modules/dates';
import { sendRequest } from '../../../../modules/admin';
import { isEqualDate, keys } from '../../utilities/calendarData.js';
import { StateProvider as CalendarProvider, initialState, reducer, useStateValue } from './calendar.context';


function CalendarManager({ dates, sendRequest }) {
  const [{ controllers }, dispatch] = useStateValue();
  const notThisMonth = () => _.clone({ backgroundColor: colours.lightGray });

  useEffect(() => {
    dispatch({ type: 'updateDates', dates: dates})
  }, [dates])

  const getStyle = (date, sameMonth) => {
    var isSelected = false;
    if (controllers.userAction === 'selectRange' && controllers.selectedDates.length === 2) {
      var matchOne = isEqualDate(controllers.selectedDates[0], date) || isEqualDate(controllers.selectedDates[1], date);
      var matchTwo = date.isBetween(controllers.selectedDates[0], controllers.selectedDates[1]);
      isSelected = matchOne || matchTwo;
    } else if (controllers.userAction !== null) {
      var foundDate = controllers.selectedDates.find(selectedDate => isEqualDate(date, selectedDate) );
      if (foundDate && foundDate !== null) {
        isSelected = true;
      }
    }

    var day = date.day() + '';
    for (var i = 0; i < dates.length; i++) {
      var dateOne = moment(dates[i].startDate);
      var isInRange, matchesDate;

      if (dates[i].endDate !== 'endless') {
        var dateTwo = moment(dates[i].endDate);

        isInRange = date.isAfter(dateOne, 'day') && date.isBefore(dateTwo, 'day');
        matchesDate = isEqualDate(dateOne, date) || isEqualDate(dateTwo, date);
      } else {
        isInRange = date.isAfter(dateOne, 'day');
        matchesDate = isEqualDate(dateOne, date);
      }

      if (isInRange || matchesDate) {
        var style = { backgroundColor: dates[i][day].peak ? colours.pink : colours.blue, color: 'white' };
        if (!sameMonth) {
          style = notThisMonth();
        }
        if (isSelected) {
          style.borderWidth = 3;
          style.borderStyle = 'solid';
          style.borderColor = colours.darkPrimary;
        }
        return style;
      }
    }

    return { backgroundColor: 'white' };
  }

  const renderView = (date, i, sameMonth, cellHeight) => {
    return (
      <LongPress
        key={i}
        longPressTime={1000}
        onShortPress={() => {}}
        onLongPress={() => onLongPress(date)}
        className="calenderDate"
        style={{ height: cellHeight, ...(getStyle(date, sameMonth)) }}
      >
        <div >
          {Number(date.format('DD'))}
        </div>
      </LongPress>
    )
  }

  const getKeyView = (key, i) => {
    return (
      <div key={i} className={key.style + ' calendarKey'} >
        {key.name}
      </div>
    )
  }

  const onLongPress = (date) => dispatch({
    type: 'userAction',
    userAction: 'selectRange',
    selectedDate: date
  })

  // const onPress = (date) => dispatch({
  //   type: 'userAction',
  //   userAction: 'selectDates',
  //   selectedDate: date
  // })

  return (
    <div className="calendarManager">
      <div className="calederWithKeys">
        <div className="calendarSection">
          <CalendarComponent renderView={renderView} />
        </div>
        <SectionSpacing />
        <Section title={config.keysSection} height={'auto'}>
          <div className="calendarKeys">
            {keys.map(getKeyView)}
          </div>
        </Section>
      </div>
      <SectionSpacing />
      <div className="actionsSection">
        <CalendarActions sendRequest={sendRequest}/>
      </div>
    </div>
  )
}

function Calendar({ isOpen, sendRequest, dates }) {
  const [tab, setTab] = useState(0)
  const [tabs, setTabs] = useState([]);

  useEffect(() => {
    sendRequest(fetchDates);
    var cb = (i) => setTab(i);

    setTabs([{name: 'Calendar', cb: () => cb(0) }, {name: 'List', cb: () => cb(1)}]);
  }, [])

  return (
    <div className={"component" + (isOpen ? '' : ' componentClosed')}>
      <Header title={config.mainTitle} tip={config.subHeading} icon={config.titleIcon} tabs={tabs} selected={tab}/>
      <CalendarProvider initialState={initialState} reducer={reducer}>
        <CalendarManager dates={dates} sendRequest={sendRequest}/>
      </CalendarProvider>
    </div>
  )
}

const mapStateToProps = ({ dates }) => ({
  dates: dates.data
})

const mapDispatchToProps = dispatch => bindActionCreators({ sendRequest }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Calendar)
